import React from "react";
import Header from "../components/home/Header";
import ProcessList from "../components/home/ProcessList";

const HomePage = () => {
  return (
    <>
      <Header />
      <ProcessList />
    </>
  );
};

export default HomePage;
